export const dashboardTabsVariants = {
  communities: 'communities',
  courses: 'courses',
};
